export default "__VITE_ASSET__Dfki9LuL__"